var _g, _defs, _defs2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCodeD(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 18,
    viewBox: "0 0 30 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12908_51392)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.61798 0.996582L0.864258 8.09234L0 8.99996L0.864258 9.90757L7.61798 17.0029V13.3729L3.45584 8.99996L7.61798 4.62703V0.996582ZM22.3824 17.0033L29.1361 9.90757L30 8.99996L29.1361 8.09234L22.3824 0.996582V4.62703L26.5445 8.99996L22.3824 13.3729V17.0033Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7901 15.0684L18.1919 14.6457L22.7021 9.90761L23.5659 9L22.7021 8.09239L15.8636 0.907612L14.9998 0L14.1359 0.907612L7.29746 8.09239L6.43359 9L7.29746 9.90761L14.9998 18L16.7275 16.1844L9.88944 9L14.9998 3.63045L20.1105 9L16.4642 12.8305L16.0624 13.2531L17.7901 15.0684Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12908_51392"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 18,
    fill: "white"
  })))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_paint",
    x1: 9.17674,
    y1: 0.634155,
    x2: 9.17674,
    y2: 17.8446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E85EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DD9FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeD);
export default __webpack_public_path__ + "static/media/code-d.bb0dafd3cffbafb37646030866d5c4f7.svg";
export { ForwardRef as ReactComponent };